import { useEffect } from "react";
import {batch, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from "@signals";
import {productPagesDetailsIsEmpty, productPagesDetailsSubmittedFilters} from "../@signals";
import useProductPageDetailsRoleConfig from "./useRoleConfig";


export default function useDigitalShelfProductPages() {

	const { urlApi } = useProductPageDetailsRoleConfig()

	const data = useSignal([])
	const summary = useSignal([])
	const kpiConfig = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			postSubmit(urlApi, commonFiltersValue.value).then(res => batch(() => {
				productPagesDetailsSubmittedFilters.value = commonFiltersValue.peek()
				if(!res.data.length)
					productPagesDetailsIsEmpty.value = true
				data.value = res.data
				summary.value = res.summary
				kpiConfig.value = res.kpiConfig
			}))
			.catch(() => isSystemBusy.value = true)
			.finally(() => { isLoadingCommonFilters.value = false})
		})
	}, [isLoadingCommonFilters.value])

	return {
		data: data.value,
		summary: summary.value,
		kpiConfig: kpiConfig.value
	}
}